import { SurveyGroup } from '@zencity/survey-types';
import { ReportBuilderClientData } from 'screens/WidgetGenerator/reportGeneratorComponents/types';

export const surveyGroupLabel = (instance: SurveyGroup): string => `${instance.title_for_display} (${instance.type})`;

export const surveyGroupLabelForFilter = (surveyGroupId: number, clientData: ReportBuilderClientData): string => {
  const surveyGroup = clientData.surveysGroups.find((instance) => instance.id === surveyGroupId);
  if (!surveyGroup) {
    return `MISSING surveyGroup for id #${surveyGroupId}`;
  }
  return surveyGroupLabel(surveyGroup);
};
